import { FETCH_PARTNERS } from '../actionTypes';

const initialState = null;

export default function(state = initialState, action=null){
  if (action.type === FETCH_PARTNERS) {
    return {...action.payload};
  } else {
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/partners.js